import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type Role =
  | 'FAN'
  | 'CLUB_EDITOR'
  | 'CLUB_SHOP_MANAGER'
  | 'CLUB_SUPPORT'
  | 'CLUB_ADMIN'
  | 'SUPER_ADMIN'
  | 'DEVELOPER';

export interface AuthUser {
  id: string;
  email: string;
  displayName?: string;
  role: Role;
  isSuperAdmin: boolean;
  tenantSlug?: string;
}

export type AuthSource = 'firebase' | 'admin-token';

interface AuthState {
  token: string | null;
  user: AuthUser | null;
  /** Come e' stata ottenuta la sessione: admin-token = login d'emergenza, non gestito da Firebase. */
  source: AuthSource | null;
  loading: boolean;
  setAuth: (token: string, user: AuthUser, source?: AuthSource) => void;
  logout: () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      token: null,
      user: null,
      source: null,
      loading: false,
      setAuth: (token, user, source = 'firebase') => set({ token, user, source, loading: false }),
      logout: () => set({ token: null, user: null, source: null, loading: false }),
    }),
    {
      name: 'tc-auth',
      partialize: (state) => ({ token: state.token, user: state.user, source: state.source }),
    },
  ),
);
